export default __webpack_public_path__ + "static/media/gold-ingots.2cd7b4c5.png";